export default {"src":"/_next/static/media/Youtube_Icon.c75d251e.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};